import { Drawer } from "antd";
import styled from "styled-components";

export const StyledDrawer = styled(Drawer)`
  .ant-drawer-header {
    background-color: ${({ $headerBg }) =>
      $headerBg || "rgba(217, 247, 190, 1)"};

    border-bottom: none;

    .ant-drawer-header-title {
      min-width: 0;
    }

    .ant-drawer-title {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      padding-right: 15px;
    }
  }

  .ant-drawer-body {
    overflow: hidden !important;
    height: 100%;
  }
`;

export const StatusTag = styled.div`
  background: #e6f4ea;
  color: #389e0d;
  padding: 2px 8px;
  border-radius: 6px;
  font-size: 12px;
`;

export const ScrollingContainer = styled.div`
  width: 100%;
  flex: 1;
  min-height: 0;

  overflow-y: auto;

  padding-right: 8px;
  margin-top: 12px;
`;

export const DrawerContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 16px;
  width: 100%;
  height: 100%;
  min-width: 0;
  overflow: hidden;

  ul,
  ol {
    width: 100%;
    padding-left: 24px;
    margin: 0;
    box-sizing: border-box;
  }

  li {
    word-break: break-word;
    overflow-wrap: break-word;
  }
`;

export const DrawerSection = styled.div`
  display: flex;
  flex-direction: column;
`;

export const DrawerDescription = styled.div`
  font-family: Open Sans;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.5;
  color: rgba(0, 0, 0, 0.88);

  width: 100%;
  min-width: 0;

  word-break: break-word;
  overflow-wrap: break-word;

  overflow: hidden;

  ol,
  ul {
    li {
      margin-bottom: 4px;
    }
  }

  img {
    max-width: 100%;
    height: auto;
  }
`;

export const DrawerTitle = styled.div`
  font-family: Open Sans;
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  color: rgba(0, 0, 0, 0.88);

  width: 100%;
  min-width: 0;

  word-break: break-word;
  overflow-wrap: break-word;

  overflow: hidden;

  margin-bottom: 20px;
`;

export const VideoContainer = styled.div`
  width: 100%;
  height: 390px !important;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 5px;
`;

export const VideoIframe = styled.iframe`
  width: 100%;
  height: 100%;
  border: 0;
  display: block;
`;

export const DownloadContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  color: #11a7d9;
  font-family: Inter;
  font-weight: 400;
  font-size: 14px;
  margin-left: 15px;

  a,
  a:link,
  a:visited,
  a:hover,
  a:active {
    color: #11a7d9;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
`;

export const StatusChangeButton = styled.div`
  display: flex;
  align-items: center;
  width: 100% !important;
  height: 32px;
  justify-content: center;
  padding: 12px 16px;
  border-radius: 6px;
  background: rgba(17, 167, 217, 1);
  color: white;
  cursor: pointer;
  margin-top: auto;

  &:hover {
    background: rgba(17, 167, 217, 0.8);
  }
`;
